import {createAsyncThunk} from "@reduxjs/toolkit";
import {executePromise} from "../../util/sliceUtil";
import {BannerApi} from "../../api/BannerApi";
import {PageSearchTypeCondition} from "../../types/hooks/banner";

export const getBannersAsync = createAsyncThunk("banner/getBanners", (condition: PageSearchTypeCondition) =>
    executePromise(BannerApi.getBanners(condition))
);